import {
  TConfig,
  TConfigInput,
  TConfigParams,
  TTheftFeeEligibilityVehicle,
} from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';
import { featureFlag } from '../../featureFlags';

function ToggleILConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return {
    autoDiscounts: [
      AUTO_DISCOUNTS.matureDriver55,
      AUTO_DISCOUNTS.antiTheft,
      AUTO_DISCOUNTS.safeDriving,
      AUTO_DISCOUNTS.multiCar,
      AUTO_DISCOUNTS.multiPolicy,
      AUTO_DISCOUNTS.homeowner,
      AUTO_DISCOUNTS.goodStudent,
      AUTO_DISCOUNTS.distantStudent,
      AUTO_DISCOUNTS.teenDriver,
    ],
    visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
      return {
        ...visibleCoverages,
        protectionCoverages: [
          ...visibleCoverages.protectionCoverages.filter(
            ({ key }) =>
              ![
                'pet_passenger',
                'underinsured_motorist_bodily_injury_limit',
              ].includes(key)
          ),
          {
            label: 'Underinsured Motorist Bodily Injury',
            key: 'underinsured_motorist_bodily_injury_limit',
          },
          visibleCoverages.protectionCoverages.find(
            ({ key }) => key === 'pet_passenger'
          ),
        ],
        vehicleCoverages: [
          ...visibleCoverages.vehicleCoverages.filter(
            ({ key }) =>
              !['uninsured_motorist_property_damage_limit'].includes(key)
          ),
          {
            label: 'Uninsured Motorist Property Damage',
            key: 'uninsured_motorist_property_damage_limit',
          },
        ],
      };
    },
    initialCoverageValues: (
      initialCoverageValues: TConfig['initialCoverageValues']
    ) => ({
      ...initialCoverageValues,
      gap: 'false',
      temporary_ride: 'null',
      side_hustle: 'false',
      uninsured_motorist_property_damage_limit: '0',
    }),
    theftFeeConfig: isFeatureEnabled(featureFlag.IS_IL_THEFT_FEE_CONFIG_ENABLED)
      ? () => ({
          valueText: 'per qualifying vehicle',
          modalContent:
            'This is a non-refundable fee per vehicle with physical damage coverage that we collect for each policy term, pursuant to the Illinois Theft Prevention Act. The fee per vehicle will be charged at the beginning of your policy term or when a new vehicle is added to your policy.',
          eligibilityCheck: (vehicle: TTheftFeeEligibilityVehicle) =>
            !!vehicle?.variables?.comprehensive_deductible &&
            !!vehicle?.variables?.collision_deductible,
        })
      : {},
  };
}
export default ToggleILConfig;
